import styled from 'styled-components';
import {
  white, black, blue, tekoMedium, teko, openSans,
} from '../../../utils/theme';
import { BlueButtonExternal, BlueButton } from '../../../utils/atoms';
import { mobile, tablet } from '../../../utils/breakpoints';

export const Container = styled.div`
  position: relative;
  border: 2px solid #dcdcdc;
  height: 100%;
  flex-basis: 33%;
  display: flex;
  align-items: stretch;
  flex-direction: column;


  > p, div {
    width: 100%;
  }

  @media (max-width: ${tablet.max}px) {
    width: calc(90% - 10px);
  }

  @media (max-width: ${mobile.max}px) {
    padding: 0 0 2vw 0;
    width: 100%;
    height: auto;
    border: none;
  }

  .media {
    width: 100%;
    flex-shrink: 0;

    .gatsby-image-wrapper {
      width: 100% !important;
      height: auto !important;
      padding-bottom: 70%;
    }
  }
`;

export const Content = styled.div`
  padding: 27px 17px 27px 17px;
  text-align: left;
  margin: 0 auto;
  background: ${white};
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  flex-grow: 1;

  .source {
    ${openSans} font-size: 12px;
    color: ${black};
    letter-spacing: 0.4px;
    line-height: 24px;
    margin-bottom: 45px;
  }

  p {
    color: ${black};
    font-size: 12px;
  }
`;

export const Title = styled.h3`
  color: ${blue};
  ${tekoMedium} font-size: 27px;
  letter-spacing: 1.81px;
  line-height: 30px;
`;

export const ReadMoreLink = styled(BlueButton)`
  && {
    margin-top: 12px;
    text-decoration: none;
    display: inline-block;
    text-transform: uppercase;
    text-align: center;
    cursor: pointer;
    height: 33px;
    padding: 0 12px 0 9px;
    line-height: 33px;
    font-size: 20px;
    letter-spacing: 2.76px;
    text-align: center;
    ${teko};
    align-self: flex-end;
    bottom: 27px;
    left: 17px;
  }
`;

export const ReadMoreHref = styled(BlueButtonExternal)`
  && {
    margin-top: 12px;
    text-decoration: none;
    display: block;
    width: 116px;
    text-transform: uppercase;
    text-align: center;
    cursor: pointer;
    height: 33px;
    padding: 0;
    line-height: 33px;
    font-size: 20px;
    letter-spacing: 2.76px;
    text-align: center;
    align-self: flex-end;
    ${teko};
  }
`;

export const FlexWrap = styled.div`
  flex: 1 0 auto;
`;



// WEBPACK FOOTER //
// ./src/components/carousel/styles/carousel-article.style.js